import { InformationCircleIcon } from '@heroicons/react/outline';
import { OpenNavButton } from '@mosey/handbook/components';
import { useEffect } from 'react';
import {
  useNavigation,
  useRouteLoaderData,
  useSearchParams,
} from 'react-router-dom';
import { useLegalEntityRegions } from '../../../hooks/useUser';
import { Menu } from '@headlessui/react';
import { MenuButton } from '@mosey/components/menus/MenuButton';
import { MenuItems } from '@mosey/components/menus/MenuItems';
import { MenuItem } from '@mosey/components/menus/MenuItem';

export const HandbookPreviewHeader = () => {
  const hasChanges = useRouteLoaderData('handbookHasChanges');
  const regions = useLegalEntityRegions();
  const regionOptions = regions.filter((region) => region.has_employees);
  const [searchParams, setSearchParams] = useSearchParams();
  const region = searchParams.get('region') || '';
  const regionLabel =
    regionOptions.find(({ code }) => code === region)?.name || region;
  const { state } = useNavigation();

  useEffect(() => {
    if (!region && regionOptions[0]?.code) {
      setSearchParams({ region: regionOptions[0].code });
    }
  }, []);

  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-3 border-b border-teal-400 bg-teal-50 px-4 shadow-sm sm:px-6 lg:px-8">
      <OpenNavButton />
      <InformationCircleIcon className="size-6 text-teal-900" />
      <p className="flex-1 text-teal-900">
        {hasChanges ? (
          <>
            <span className="font-semibold">
              This is a preview<span className="lg:hidden">.</span>
            </span>
            <span className="hidden lg:inline">
              {' '}
              &mdash; pending changes have not yet been published.
            </span>
          </>
        ) : (
          <span className="font-semibold">This is a preview.</span>
        )}
      </p>
      {regionOptions.length > 0 && (
        <div className="flex items-center gap-3">
          <span className="hidden text-nowrap text-teal-900 md:inline">
            Select location:
          </span>
          <Menu>
            <MenuButton
              aria-describedby="handbook-preview-region-select"
              isLoading={state === 'loading'}
            >
              {regionLabel ? regionLabel : 'Select state...'}
            </MenuButton>

            <span id="handbook-preview-region-select" className="sr-only">
              This menu allows you to choose which state specific policies
              should be included in the preview.
            </span>

            <MenuItems anchor={{ to: 'bottom end', gap: 8, padding: 8 }}>
              {regionOptions.map(({ id, code, name }) => {
                return (
                  <MenuItem
                    as="button"
                    onClick={() => setSearchParams({ region: code })}
                    key={id}
                    aria-pressed={region === code}
                    selected={region === code}
                  >
                    {name}
                  </MenuItem>
                );
              })}
            </MenuItems>
          </Menu>
        </div>
      )}
    </div>
  );
};
